var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-skeleton-loader',_vm._b({attrs:{"type":"card-avatar"}},'v-skeleton-loader',_vm.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }